import { AgeGateModal } from '@jane/shared-ecomm/components';

import { selectApplication } from '../customer/redux/application';
import { useCustomerSelector } from '../customer/selectors';
import { CartAlerts } from './cartAlerts';
import { LoginModal } from './loginModal';
import { Logout } from './logout';
import { Registration } from './registration/container';
import { ReplaceCart } from './replaceCart';

const MODALS = {
  ageGate: AgeGateModal,
  cartAlerts: CartAlerts,
  login: LoginModal,
  logout: Logout,
  register: Registration,
  replaceCart: ReplaceCart,
};

export const Modals = () => {
  const { modalName, modalOptions } = useCustomerSelector(selectApplication);

  if (modalName) {
    const CurrentModal = MODALS[modalName];
    if (!CurrentModal) throw new Error(`Cannot find modal: ${modalName}`);
    return <CurrentModal {...modalOptions} />;
  }

  return null;
};
